import {useState} from "react";
import chroma from "chroma-js";
import axios from "axios";
import Button from "./Button";
import Modal from "./Modal";
import LargeButton from "./LargeButton";
import {faCompass, faPencil} from "@fortawesome/free-solid-svg-icons";
import {GridRow, ColumnGrid} from "./ColumnGrid";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import config from '../config.json';

const TemplateOption = ({ template }) => {
    const [ showModal, setShowModal ] = useState(false);

    const [ name, setName ] = useState("");

    const [ color ] = useState(chroma.hsl(Math.floor(Math.random() * 360), 0.8, 0.4));

    const create = async () => {
        setShowModal(false);

        axios({
            url: `${config.backendUrl}/maps`,
            withCredentials: true,
            method: "post",
            data: { name, template: template._id }
        })
            .then(response => window.location = "/maps?edit=" + response.data.id)
            .catch(error => alert(error.toString()));
    };

    const footer = (
        <div style={{ display: "flex", gap: "20px" }}>
            <Button color="#40b319" onClick={create} content="Create"/>
            <Button color="#c20a0a" onClick={() => setShowModal(false)} content="Cancel"/>
        </div>
    );

    return (
        <div>
            <Modal
                header={`New Map: ${template.name}`}
                footer={footer}
                show={showModal}
                onClose={() => setShowModal(false)}>
                <ColumnGrid columns="20px 1fr 1fr">
                    <GridRow>
                        <FontAwesomeIcon icon={faPencil}/>
                        <span>Name</span>
                        <input id="name" type="text" onInput={e => setName(e.target.value)}/>
                    </GridRow>
                </ColumnGrid>
            </Modal>
            <LargeButton
                name={template.name}
                desc='Create and edit'
                icon={faCompass}
                color={color}
                onClick={() => setShowModal(true)}/>
        </div>
    );
}

export default TemplateOption;
